<script>
	import { getContext } from 'svelte'

    import firebase from "firebase/app"
    import "firebase/firestore"

    const firebaseConsoleUrl = getContext("firebaseConsoleUrl")

    let adminLog = [
        // {time: firebase.firestore.Timestamp.fromDate(new Date()), text: "I am a very simple card."},
        // {time: firebase.firestore.Timestamp.fromDate(new Date()), text: "I am good at containing small bits of information."},
        // {time: firebase.firestore.Timestamp.fromDate(new Date()), text: "I am convenient because I require little markup to use effectively."},
    ]

    firebase.firestore().collection("AdminActionLog")
                        .orderBy('time', 'desc')
                        .limit(20)
                        .onSnapshot(querySnapshot => {
        let newAdminLog = []
        querySnapshot.forEach((item) => {
            newAdminLog.push(item.data())
        })
        adminLog = newAdminLog
    }, err => {
        console.log(`Encountered error: ${err}`)
		//alert(err)
    });    

</script>


<div class="card teal darken-1"> <!-- TODO background style must be in global.css-->
    <div class="card-content white-text">
        <span class="card-title">Admin actions</span>
            {#each adminLog as item}
                <div class="admin-action-log-time">{item.time.toDate().toLocaleString()}</div>
                <div class="admin-action-log-text">{@html item.text}</div>
            {/each}
    </div>
    <div class="card-action">
        <a href={firebaseConsoleUrl + "/firestore/data~2FAdminActionLog"}>Full log</a>
    </div>
</div>


<style>

</style>